module.exports = __webpack_public_path__ + "img/about-6.84a12224.jpg";